import { z } from 'zod';
import { LEVELS, ROLES, CATEGORIES, define, DEFINITION_KINDS } from '../types.js';

/**
 * Calculate serviceability by delivery distance.
 */
export const schema = z.boolean();

export type ServiceableRadiusByDelivery = z.infer<typeof schema>;

export const definition = define({
  key: 'serviceable_radius_by_delivery',
  schema,
  label: 'Delivery Verification for HopDrive Service Radius',
  description: 'Toggle on to verify that the delivery address is within the HopDrive Service Radius.',
  kind: DEFINITION_KINDS.SETTING,
  category: CATEGORIES.SERVICE_RADIUS.key,
  writableAtLevels: [LEVELS.CUSTOMER],
  readableByRoles: [ROLES.ADMIN],
});
